import React from 'react';
import { Button, Stack } from '@mui/material';

export const canShowWorkflowActions = (status) =>
  ['pending', 'proposal_pending', 'proposal_expired'].includes(status);

export default function AppointmentWorkflowActions({
  appointment,
  onConfirm,
  onModifyConfirm,
  onPropose,
  onCancel,
  labels,
  busy = false,
}) {
  if (!appointment || !canShowWorkflowActions(appointment.status)) return null;
  const outlinedSx = {
    color: '#8b4d27',
    borderColor: '#c9906b',
    '&:hover': { borderColor: '#8b4d27', backgroundColor: '#fff4e8' },
  };

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={1.25}
      useFlexGap
      flexWrap="wrap"
      sx={{ '& .MuiButton-root': { minHeight: 44, px: 2.25 } }}
    >
      {appointment.status === 'pending' && (
        <Button
          variant="contained"
          disabled={busy}
          onClick={onConfirm}
          sx={{ backgroundColor: '#a45b2a', '&:hover': { backgroundColor: '#82451f' } }}
        >
          {labels.confirm}
        </Button>
      )}
      {appointment.status === 'pending' && (
        <Button variant="outlined" disabled={busy} onClick={onModifyConfirm} sx={outlinedSx}>
          {labels.modify}
        </Button>
      )}
      {['pending', 'proposal_expired'].includes(appointment.status) && (
        <Button variant="outlined" disabled={busy} onClick={onPropose} sx={outlinedSx}>
          {labels.propose}
        </Button>
      )}
      <Button variant="text" color="error" disabled={busy} onClick={onCancel}>
        {labels.cancel}
      </Button>
    </Stack>
  );
}
